<template>
  <div id="address">
    <el-form
      :model="addressForm"
      ref="addressForm"
      label-width="100px"
      size="small"
      class="demo-addressForm"
    >
      <el-form-item label="收货人:">
        <div class="addressFormItem">
          <div class="addressFormInputItem">
            <el-input v-model="addressForm.name.value"></el-input>
          </div>
          <span v-if="addressForm.name.warning" class="warning">{{addressForm.name.warning}}</span>
        </div>
      </el-form-item>
      <el-form-item label="手机号:">
        <div class="addressFormItem">
          <div class="addressFormInputItem">
            <el-input v-model="addressForm.phone.value"></el-input>
          </div>
          <span v-if="addressForm.phone.warning" class="warning">{{addressForm.phone.warning}}</span>
        </div>
      </el-form-item>
      <el-form-item label="省/市/区:">
        <div class="addressFormItem">
          <div class="addressFormInputItem _cascader">
            <el-cascader
              v-model="addressForm.areaId.value"
              :options="citysArr"
              @change="handleChange"
            ></el-cascader>
          </div>
          <span v-if="addressForm.areaId.warning" class="warning">{{addressForm.areaId.warning}}</span>
        </div>
      </el-form-item>

      <el-form-item label="详细地址">
        <div class="addressFormItem">
          <div class="addressFormInputItem">
            <el-input type="textarea" rows="3" v-model="addressForm.detailAdress.value"></el-input>
          </div>
          <span
            v-if="addressForm.detailAdress.warning"
            class="warning"
          >{{addressForm.detailAdress.warning}}</span>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button type="danger" @click="submitForm('addressForm')">添加地址</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {addAddressUrl} from "@/api/api";
import city from "@/utils/city.js";
import {mapState} from 'vuex'
export default {
  props:['addSuccess','addFail'],
  data() {
    return {
      addressForm: {
        name: {
          value: "",
          reg: [{ rule: /\S/, info: "*收货人姓名不能为空" }],
          warning: ""
        },
        phone: {
          value: "",
          reg: [
            { rule: /^1[3456789]\d{9}$/, info: "*收货人手机号格式有误" },
            { rule: /\S/, info: "*收货人手机号不能为空" }
          ],
          warning: ""
        },
        areaId: {
          value: "",
          reg: [{ rule: /\S/, info: "*请选择配送省市区" }],
          warning: ""
        },
        detailAdress: {
          value: "",
          reg: [{ rule: /\S/, info: "*请填写详细收货地址" }],
          warning: ""
        }
      },
         citysArr: null,
    };
  },
  computed:{
    ...mapState(['userInfo'])
  },

  methods: {
      handleChange(e) {},
       getCityData() {
         console.log('city')
         console.log(city)
       this.citysArr = city;
    },
    testAddAddres(form) {
      let flag = true;
      for (var k in form) {
        let { value, reg, warning } = form[k];
        if (reg) {
          let showTips = [];
          reg.forEach(item => {
            if (!item.rule.test(value)) {
              form[k].warning = item.info;
              flag = false;
              showTips.push(true);
            } else {
              showTips.push(false);
            }
          });
          showTips.every(item => item == false) && (form[k].warning = "");
        }
      }
      return flag;
    },
    submitForm(formName) {
      if (this.testAddAddres(this.addressForm)) {
        this.addAddress();
      }
    },
      addAddress() {
      let url = addAddressUrl;
      let { name, phone, areaId, detailAdress } = this.addressForm;
     console.log('detailAdress')
     console.log(detailAdress)
    //  return
      let data = {
        name: name.value,
        phone: phone.value,
        address: detailAdress.value,
        areaId: areaId.value[2],
        access_token: this.userInfo.access_token
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url
      })
        .then(res => {
          console.log(res);
          if (res.data.resultCode == 1) {
            this.$emit('addSuccess')
            let addressForm = JSON.parse(JSON.stringify(this.addressForm))
            for(var k in addressForm){
              addressForm[k].value=''
              addressForm[k].warning=''
            }
            this.addressForm = addressForm
          } else {
            this.$emit('addFail')
            this.$alert(res.data.resultMsg);
          }
        })
        .catch(err => {
          this.$emit('addFail')
          this.$alert(err.msg);
        });
    },
  },
  created(){
    this.getCityData()
  },
};
</script>

<style lang='less' scoped>
.addressFormItem {
    display: flex;
  }
  .warning {
    color: #dd2727;
    margin-left: 10px;
  }
  .addressItem {
    display: flex;
    height: 36px;
    align-items: center;
    // background-color: yellow;
  }
  .addressItemTag {
    border: 1px solid #666;
    padding: 0px 20px;
    margin-right: 20px;
    width: 120px;
    text-align: center;
  }
  .addressBoxItem {
    max-width: 1100px;
    height: 36px;
    display: flex;
    padding: 0 20px 0 0;
    border: 1px solid #fff;
    justify-content: space-between;
    margin-bottom: 10px;
  }
  ._cascader{
    max-width: 185px;
  }
</style>


// WEBPACK FOOTER //
// src/components/components/Address/AddressComponent.vue